<script lang="ts">
	import type { Geometry } from '$lib/components/map/types';
	import { GeoJSON, LineLayer } from 'svelte-maplibre';

	interface Props {
		geometry: Geometry;
		layout?: maplibregl.LineLayerSpecification['layout'];
		outterPaint?: maplibregl.LineLayerSpecification['paint'];
		innerPaint?: maplibregl.LineLayerSpecification['paint'];
		onPolylineClick?: (index: number) => void;
	}

	const {
		geometry,
		layout,
		outterPaint,
		innerPaint,
		onPolylineClick = () => {},
	}: Props = $props();

	function handleClick() {
		onPolylineClick(geometry.index);
	}
</script>

<GeoJSON data={geometry.line}>
	<LineLayer {layout}
		paint={outterPaint}
		id={`route-outter-line-${JSON.stringify(geometry.line.coordinates)}`}
		beforeId="Itineraires_Selectione_Info_Traffic"
	/>
	<LineLayer
		{layout}
		paint={innerPaint}
		onclick={handleClick}
		id={`route-inner-line-${JSON.stringify(geometry.line.coordinates)}`}
		beforeId="Itineraires_Selectione_Info_Traffic"
	/>
</GeoJSON>
